import {Injectable} from '@angular/core';
import {HammerGestureConfig} from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class GestureHandlerService extends HammerGestureConfig {

  overrides = <any> {
    'tap': { threshold: 500, posTreshold: 10, time: 1000 }, // default 2, 10
    'pan': { threshold: 5000, posTreshold: 2, direction: 30 } // default 2, 10
  };
}
